/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Grade_Adjusted_Pace_RangeInputs */

const en_exp_grade_adjusted_pace_range = /** @type {(inputs: Exp_Grade_Adjusted_Pace_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read it like pace (min/km). Uphill, GAP is faster than your actual pace. Gentle descents (around −5 to −10 %) are the easiest running, so GAP is slower there. On steeper descents braking costs effort again — GAP moves back toward your pace and can get faster. Stops and pauses don't count.`)
};

const de_exp_grade_adjusted_pace_range = /** @type {(inputs: Exp_Grade_Adjusted_Pace_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lies es wie Tempo (min/km). Bergauf ist GAP schneller als dein echtes Tempo. Leichtes Gefälle (etwa −5 bis −10 %) läuft sich am leichtesten — dort ist GAP langsamer. Wird es steiler, kostet das Bremsen wieder Kraft: GAP rückt an dein Tempo heran und kann schneller werden. Pausen zählen nicht.`)
};

/**
* | output |
* | --- |
* | "Read it like pace (min/km). Uphill, GAP is faster than your actual pace. Gentle descents (around −5 to −10 %) are the easiest running, so GAP is slower there..." |
*
* @param {Exp_Grade_Adjusted_Pace_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_grade_adjusted_pace_range = /** @type {((inputs?: Exp_Grade_Adjusted_Pace_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Grade_Adjusted_Pace_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_grade_adjusted_pace_range(inputs)
	return de_exp_grade_adjusted_pace_range(inputs)
});